<template>
  <article class="Trainings">
    <header-background
      :image-src="headerImageSrc"
      class="Trainings-Banner"
      title="Treinamentos e Desenvolvimento Profissional"
    />

    <the-title
      id="top-title"
      class="Trainings-Title"
    >Treinamentos e Desenvolvimento Profissional</the-title>

    <p class="Trainings-Paragraph">
      Realizamos Treinamentos nas áreas específicas da Administração, Assistência Social, Educação e Saúde, de acordo
      com o levantamento de necessidades.
    </p>

    <p class="Trainings-Paragraph Trainings-Paragraph--highlighted">
      Todos os cursos e treinamentos oferecidos pela CSC, dão aos participantes o direito da emissão de certificados.
      Os certificados são registrados com um código, que permite a posterior consulta da sua veracidade e validação.
    </p>

    <div class="Trainings-ButtonWrapper">
      <the-button
        class="Trainings-Button"
        @click="openCertificates"
      >
        <the-icon icon="graduation"/>
        CLIQUE AQUI PARA EMITIR SEU CERTIFICADO
      </the-button>
    </div>


    <p class="Trainings-Paragraph">
      Utilize a lista abaixo para navegar diretamente para um dos temas ou role a página para conferir todos.
    </p>

    <ul class="Trainings-List">
      <li class="Trainings-ListItem">
        <a
          class="Trainings-SummaryLink"
          title="Clique para navegar diretamente até os temas da área da Administração."
          @click="goToCollapse($event, 'area-da-administracao', 'collapse-area-da-administracao')"
        >Área da Administração</a>;
      </li>

      <li class="Trainings-ListItem">
        <a
          class="Trainings-SummaryLink"
          title="Clique para navegar diretamente até os temas da área da Assistência Social."
          @click="goToCollapse($event, 'area-da-assistencia-social', 'collapse-area-da-assistencia-social')"
        >Área da Assistência Social</a>;
      </li>

      <li class="Trainings-ListItem">
        <a
          class="Trainings-SummaryLink"
          title="Clique para navegar diretamente até os temas da área da Educação."
          @click="goToCollapse($event, 'area-da-educacao', 'collapse-area-da-educacao')"
        >Área da Educação</a>;

        <ul class="Trainings-List">
          <li class="Trainings-ListItem">
            <a
              class="Trainings-SummaryLink"
              title="Clique para navegar diretamente até os temas da área da Educação Infantil."
              @click="goToCollapse($event, 'area-da-educacao-infantil', 'collapse-area-da-educacao')"
            >Área da Educação Infantil</a>;
          </li>

          <li class="Trainings-ListItem">
            <a
              class="Trainings-SummaryLink"
              title="Clique para navegar diretamente até os temas da área da Educação Fundamental I."
              @click="goToCollapse($event, 'area-da-educacao-fundamental-i', 'collapse-area-da-educacao')"
            >Área da Educação Fundamental I</a>.
          </li>
        </ul>
      </li>
    </ul>

    <p class="Trainings-Paragraph">
      <b>Clique sobre os temas para ver mais detalhes.</b>
    </p>

    <collapse-block-with-image
      id="area-da-administracao"
      ref="collapse-area-da-administracao"
      :start-expanded="false"
      class="Trainings-Collapsable"
      icon="chart_pie"
      image-url="/img/background-business-people.jpg"
      title="Área da Administração"
    >
      <p class="Trainings-Paragraph">
        Alguns dos temas que atendemos na área da Administração:
      </p>

      <ul class="Trainings-List">
        <li class="Trainings-ListItem">Gestão do relacionamento, gestão da mudança, gestão de inovação;</li>

        <li class="Trainings-ListItem">Ferramentas de gestão e operacionalização de projetos, processos e atividades;</li>

        <li class="Trainings-ListItem">Liderança Transformacional;</li>

        <li class="Trainings-ListItem">Qualidade no Atendimento com Motivação e Convivência no Ambiente de Trabalho;</li>

        <li class="Trainings-ListItem">Trabalho em Equipe - Desenvolvimento e comprometimento;</li>

        <li class="Trainings-ListItem">Comunicação Assertiva, <i>Autofeedback</i> e <i>Feedback</i>;</li>

        <li class="Trainings-ListItem">Diagnóstico de problemas e proposta de solução;</li>

        <li class="Trainings-ListItem">Relações Humanas e Ética Profissional;</li>

        <li class="Trainings-ListItem">Assédio Moral;</li>

        <li class="Trainings-ListItem">Protocolos Sanitários em tempos de Pandemia e Pós-Pandemia.</li>
      </ul>

      <p class="Trainings-Paragraph Trainings-Paragraph--center">
        <a
          class="Trainings-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-area-da-administracao')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <collapse-block-with-image
      id="area-da-assistencia-social"
      ref="collapse-area-da-assistencia-social"
      :start-expanded="false"
      class="Trainings-Collapsable"
      image-url="/img/background-social-assistance.jpg"
      image-alt="A imagem contém um coração simbólico nas mãos de um adulto e de uma criança."
      side="right"
      icon="users"
      title="Área da Assistência Social"
    >
      <p class="Trainings-Paragraph">
        Alguns dos temas que atendemos na área da Assistência Social:
      </p>

      <ul class="Trainings-List">
        <li class="Trainings-ListItem">
          Capacitação para Conselhos de Políticas Públicas – Conselho Municipal da Criança e do Adolescente, Conselho
          Municipal da Assistência Social, Conselho do Idoso, Conselho da Mulher e Conselho da Pessoa com Deficiência;
        </li>

        <li class="Trainings-ListItem">
          Capacitação e formação continuada para Educadores Sociais, Trabalhadores do CRAS, CREAS, das Medidas
          Socioeducativas, PAIF e PAEF, Serviços de Convivência e Fortalecimento de Vínculos Profissionais que atuam no
          Acolhimento Institucional;
        </li>

        <li class="Trainings-ListItem">
          Palestras temáticas no âmbito da Assistência Social: Palestras com temas variados, de acordo com a necessidade
          apresentada pelos municípios;
        </li>

        <li class="Trainings-ListItem">
          Capacitação e formação continuada para Conselheiros Tutelares (com cursos e/ou treinamentos), podendo ser a
          curto e longo prazo, auxiliando os Conselheiros Tutelares a desenvolverem suas habilidades profissionais.
          Essa capacitação pode ser focada em competências técnicas ou comportamentais.
        </li>
      </ul>

      <p class="Trainings-Paragraph Trainings-Paragraph--center">
        <a
          class="Trainings-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-area-da-assistencia-social')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>

    <collapse-block-with-image
      id="area-da-educacao"
      ref="collapse-area-da-educacao"
      :start-expanded="false"
      image-url="/img/background-education.jpg"
      image-alt="A imagem contém uma sala de aula infantil com uma fileira de carteiras e uma aluna em primero plano."
      class="Trainings-Collapsable"
      icon="graduation"
      title="Área da Educação"
    >
      <p class="Trainings-Paragraph">
        Alguns dos temas que atendemos na área da Educação:
      </p>

      <ul class="Trainings-List">
        <li class="Trainings-ListItem">
          Qualidade no Atendimento e Motivação Escolar (diretores, coordenadores, professores e apoio escolar);
        </li>

        <li class="Trainings-ListItem">
          Relações Humanas, Liderança e Comunicação: competências essenciais (diretores, coordenadores, professores e
          apoio escolar);
        </li>

        <li class="Trainings-ListItem">Trabalho em Equipe (diretores, coordenadores, professores e apoio escolar);</li>

        <li class="Trainings-ListItem">Assédio Moral (diretores, coordenadores, professores e apoio escolar);</li>

        <li class="Trainings-ListItem">Gestão Educacional e Gestão Escolar;</li>

        <li class="Trainings-ListItem">Gestão Escolar Democrática;</li>

        <li class="Trainings-ListItem">Formação de Diretores e Coordenadores;</li>

        <li class="Trainings-ListItem">Avaliação Interna da Qualidade da Educação Infantil e Fundamental I;</li>

        <li class="Trainings-ListItem">
          Protocolos Sanitários em tempos de Pandemia e Pós-Pandemia (diretores, coordenadores, professores e apoio
          escolar);
        </li>

        <li class="Trainings-ListItem">Educação Especial Inclusiva;</li>

        <li class="Trainings-ListItem">
          Legislação Educacional (CF, LDB, Diretrizes, PCN, BNCC, FUNDEB, PISO, PME, PAR, PNAIC, PDDE, PPA, LDO, LOA);
        </li>

        <li class="Trainings-ListItem">Didática e Prática Pedagógica para Docentes;</li>

        <li class="Trainings-ListItem">Família e Escola: uma parceria que pode dar muito certo;</li>

        <li class="Trainings-ListItem">Saúde do docente: prevenção e cuidados;</li>

        <li class="Trainings-ListItem">Comunicação na Sala de Aula;</li>

        <li class="Trainings-ListItem">Construindo o Perfil do Professor Humanizador;</li>

        <li class="Trainings-ListItem">O Papel do Motorista e Monitor do Transporte Escolar;</li>

        <li class="Trainings-ListItem">Práticas da Secretaria Escolar;</li>

        <li class="Trainings-ListItem">
          Treinamento em 1º socorros (diretores, coordenadores, professores e apoio escolar);
        </li>

        <li
          id="area-da-educacao-infantil"
          class="Trainings-ListItem Trainings-ListItem--hasChildren"
        >
          A – Educação Infantil:

          <ul class="Trainings-List">
            <li class="Trainings-ListItem">
              A atuação pedagógica na construção da educação infantil: fases do desenvolvimento infantil, afetividade, espaço,
              tempo e ações cotidianas;
            </li>

            <li class="Trainings-ListItem">A Psicomotricidade na Educação Infantil;</li>

            <li class="Trainings-ListItem">
              A importância do Brincar na Educação Infantil: brinquedos, brincadeira, jogos e interações;
            </li>

            <li class="Trainings-ListItem">O papel da família e da escola na educação infantil;</li>

            <li class="Trainings-ListItem">
              Aprendizagem e desenvolvimento na educação infantil – O que apontam Piaget, Vygotsky e Wallon;
            </li>

            <li class="Trainings-ListItem">A matemática na Educação Infantil;</li>
          </ul>
        </li>

        <li
          id="area-da-educacao-fundamental-i"
          class="Trainings-ListItem Trainings-ListItem--hasChildren"
        >
          B – Educação Fundamental I:

          <ul class="Trainings-List">
            <li class="Trainings-ListItem">Jogos matemáticos - Do lúdico à aprendizagem;</li>

            <li class="Trainings-ListItem">Matemática um grande desafio – Ensino Fundamental I;</li>

            <li class="Trainings-ListItem">Obras de arte um rico instrumento de aprendizagem;</li>

            <li class="Trainings-ListItem">Recreação como forma de intervenção pedagógica;</li>

            <li class="Trainings-ListItem">Sucata, mil possibilidades de aprendizagem;</li>

            <li class="Trainings-ListItem">Contação de histórias.</li>
          </ul>
        </li>
      </ul>

      <p class="Trainings-Paragraph Trainings-Paragraph--center">
        <a
          class="Trainings-TopTitleLink"
          title="Clique para voltar ao topo (sumário)"
          @click="goBackToTop($event, 'collapse-area-da-educacao')"
        >Voltar ao topo</a>
      </p>
    </collapse-block-with-image>
  </article>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .Trainings {
    width: 100%;

    &-Banner {
      margin-bottom: 10px;
    }

    &-Title {
      margin: 15px 20px;
    }

    &-ButtonWrapper {
      margin: 15px 20px;
      max-width: 500px;
    }

    &-Subtitle {
      margin: 15px 20px;
      font-size: 18px;
      font-weight: 800;
      padding-left: 10px;
    }

    &-SubSubTitle {
      margin: 15px 20px;
      font-size: 16px;
      font-weight: 800;
      padding-left: 10px;
    }

    &-Collapsable {
      margin: 15px 30px;
    }

    &-Paragraph {
      margin: 15px 30px;

      &--center {
        text-align: center;
      }

      &--highlighted {
        font-weight: bold;
      }
    }

    &-List {
      margin: 10px 30px;
      font-weight: 400;
    }

    &-ListItem {
      font-weight: 400;
      margin: 5px 0;

      &--hasChildren {
        font-weight: bold;
      }
    }
  }
</style>

<script>
  import { CollapseMixin } from "@/common/mixins";
  import HeaderBackground from "@/components/HeaderBackground";
  import TheButton from "@/components/TheButton";
  import TheIcon from "@/components/TheIcon";
  import TheTitle from "@/components/TheTitle";
  import CollapseBlockWithImage from '@/components/CollapseBlockWithImage.vue';

  export default {
    name: "Trainings",

    components: {
      HeaderBackground,
      TheButton,
      TheIcon,
      TheTitle,
      CollapseBlockWithImage,
    },

    mixins: [CollapseMixin],

    data() {
      return {
        headerImageSrc: "/img/backgrounds/csc-01.jpg",
      };
    },

    methods: {
      openCertificates() {
        window.open('https://csc.selecao.net.br/painel/');
      },
    },
  };
</script>
